export const STT_MESSAGES = {
  insecure: 'Voice input requires a secure HTTPS connection. Please use the secure version of INSIGHT.',
  unsupported: 'Speech-to-text is not available in this browser. Please use a supported browser or type your response.',
  permission: 'Microphone access is blocked. Please allow microphone access in your browser and try again.',
  audio: 'The microphone could not capture audio. Please check that it is connected and not being used by another application.',
  requesting: 'Waiting for microphone permission…',
  noSpeech: 'No speech was detected. Please try again.',
  network: 'Speech recognition is temporarily unavailable. Please check your connection and try again.',
  aborted: 'Voice input was stopped. You can press the microphone button to try again.',
  generic: 'Voice input could not be completed. Please try again or type your response.',
};

export const getSpeechRecognitionConstructor = () => (
  typeof window === 'undefined' ? null : (window.SpeechRecognition || window.webkitSpeechRecognition || null)
);

export const getSttAvailability = () => {
  if (typeof window === 'undefined' || window.isSecureContext !== true) {
    return { available: false, reason: 'insecure', message: STT_MESSAGES.insecure };
  }
  if (!getSpeechRecognitionConstructor()) {
    return { available: false, reason: 'unsupported', message: STT_MESSAGES.unsupported };
  }
  return { available: true, reason: null, message: '' };
};

export const getSttErrorMessage = (errorCode) => {
  switch (errorCode) {
    case 'not-allowed':
    case 'service-not-allowed': return STT_MESSAGES.permission;
    case 'audio-capture': return STT_MESSAGES.audio;
    case 'no-speech': return STT_MESSAGES.noSpeech;
    case 'network': return STT_MESSAGES.network;
    case 'aborted': return STT_MESSAGES.aborted;
    default: return STT_MESSAGES.generic;
  }
};

export const configureEnglishRecognition = (recognition) => {
  recognition.lang = 'en-US';
  recognition.continuous = true;
  recognition.interimResults = true;
  recognition.maxAlternatives = 1;
  return recognition;
};
